import React, { useState, useEffect } from "react";
import styled from "styled-components";
import firebase from "firebase";

import {
  ClassroomContainer,
  ClassroomNav,
  FormButton,
  useUserId
} from "./Classroom";

const ValueGrid = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 1rem;
  row-gap: 3rem;
  grid-template-columns: 1fr 4fr 1fr;
  padding: 3rem;
  justify-items: stretch;
  font-family: var(--body);
  @media (max-width: 768px) {
    grid-template-columns: 1fr 2fr 1fr;
  }
`;

const Title = styled.h2`
  color: var(--blue);
  font-family: var(--title);
  font-size: 2rem;
  text-align: center;
`;

const FlexArea = styled.div`
  padding: 20vmin;
  width: 100%;
  display: flex;
  flex-direction: column;
  *:first-child {
    margin-bottom: 0.5rem;
  }
`;

const Range = styled.input`
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 2rem; /* Specified height */
  background: var(--gold);
  outline: none; /* Remove outline */
  &::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 2rem; /* Set a specific slider handle width */
    height: 2rem; /* Slider handle height */
    background: var(--blue); /* Green background */
    cursor: pointer; /* Cursor on hover */
  }
  &::-moz-range-thumb {
    width: 2rem; /* Set a specific slider handle width */
    height: 2rem; /* Slider handle height */
    background: var(--blue); /* Green background */
    cursor: pointer; /* Cursor on hover */
  }
`;

export const ClassroomBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
`;

const HideableBox = styled.div`
  transition: 500ms ease-out;
  opacity: ${({ doHide }) => (doHide ? 0 : 1)};
`;

const HideableContainer = styled.div`
  border: 1px solid var(--gold);
  padding: 1rem;
`;

function Hide({ children, initialHidden = false }) {
  const [hidden, setHidden] = useState(initialHidden);
  return (
    <HideableContainer>
      <HideableBox doHide={hidden}>{children}</HideableBox>
      <FormButton onClick={() => setHidden(h => !h)}>
        {hidden ? "Reveal" : "Hide"}
      </FormButton>
    </HideableContainer>
  );
}

function ConnectedRange({ index, name }) {
  const userId = useUserId();
  const [value, setValue] = useState(5);
  return (
    <Range
      type="range"
      min="0"
      max="10"
      step="1"
      value={value}
      onChange={e => {
        const val = parseInt(e.target.value, 10);
        setValue(val);
        firebase
          .database()
          .ref(`/valuex/${name}/${userId}-${index}`)
          .set(val);
      }}
    />
  );
}

const HistorgramGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(11, 1fr);
  align-items: flex-end;
  border-bottom: 1px solid var(--blue);
`;

const HistogramCol = styled.div`
  height: ${({ count }) => count}rem;
  background-color: var(--blue);
  width: 100%;
  display: block;
`;

function Histogram({ name }) {
  const [results, setResults] = useState({});
  useEffect(() => {
    function doSetResults(snapshot) {
      setResults(snapshot.val());
    }

    console.log(`/valuex/${name}`);
    firebase
      .database()
      .ref(`/valuex/${name}`)
      .on("value", doSetResults);

    return () =>
      firebase
        .database()
        .ref(`/valuex/${name}`)
        .off("value", doSetResults);
  }, [name]);

  const replies = Object.values(results ?? {});

  const counts = Array(11)
    .fill(null)
    .map((_, i) => {
      return replies.filter(r => r === i).length;
    });

  return (
    <HistorgramGrid>
      {counts.map((c, i) => (
        <HistogramCol count={c} key={i} />
      ))}
    </HistorgramGrid>
  );
}

export function ValueSpectrum() {
  const [withPartner, setWithPartner] = useState(null);

  const boxes = withPartner === null ? 0 : withPartner ? 2 : 1;

  return (
    <ClassroomContainer>
      <ClassroomNav backToClassroom={true}></ClassroomNav>
      <ClassroomBody>
        {withPartner === null && (
          <FlexArea>
            <FormButton onClick={() => setWithPartner(true)}>
              I'm doing this activty with a partner
            </FormButton>
            <FormButton onClick={() => setWithPartner(false)}>
              I'm doing this activty solo
            </FormButton>
          </FlexArea>
        )}

        {Array(boxes)
          .fill(null)
          .map((_, i) => {
            return (
              <Hide key={i}>
                <ValueGrid>
                  <Title>Naturalist</Title>
                  <ConnectedRange index={i} name={"nat-tech"} />
                  <Title>Technologist</Title>
                  <Title>Minimalist</Title>
                  <ConnectedRange index={i} name={"min-max"} />
                  <Title>Maximalist</Title>
                  <Title>Doubter</Title>
                  <ConnectedRange index={i} name={"doubt-bel"} />
                  <Title>Believer</Title>
                </ValueGrid>
              </Hide>
            );
          })}
        <ValueGrid>
          <Title>Naturalist</Title>
          <Histogram name={"nat-tech"} />
          <Title>Technologist</Title>
          <Title>Minimalist</Title>
          <Histogram name={"min-max"} />
          <Title>Maximalist</Title>
          <Title>Doubter</Title>
          <Histogram name={"doubt-bel"} />
          <Title>Believer</Title>
        </ValueGrid>
      </ClassroomBody>
    </ClassroomContainer>
  );
}
